import { useState } from 'react';
import PropTypes from 'prop-types';

import { Tooltip, IconButton } from '@material-ui/core';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import VMTemplatePreviewModal from './VMTemplatePreviewModal';

VMTemplatePreviewButton.propTypes = {
  type: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  vm: PropTypes.object
};

VMTemplatePreviewButton.defaultProps = {
  type: 'text',
  variant: 'contained',
  color: 'primary'
};

export default function VMTemplatePreviewButton({ type, variant, color, vm }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => {
    setIsOpen(true);
  };
  return (
    <>
      <VMTemplatePreviewModal isOpen={isOpen} setIsOpen={setIsOpen} vm={vm} />
      {type === 'icononly' && (
        <Tooltip title="Preview VM Template" placement="top">
          <IconButton
            variant={variant}
            onClick={(e) => {
              e.stopPropagation();
              handleOpenModal();
            }}
            color={color}
            data-testid="vm-template-preview-button"
          >
            <InfoOutlineIcon />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
}
